import { DynamoNode, FormNode, ElementNode, NodeTag, TemplateNodeVisitor } from "dynamo-models";

import { observable } from "mobx";
import { ToolboxContainerNode } from "./toolboxNode";

export class MetaNode extends DynamoNode {
    constructor(formNode: FormNode, toolboxContainer?: ToolboxContainerNode) {
        super()
        this.formNode = formNode
        this.toolboxContainer = toolboxContainer;
    }

    public tag: NodeTag = NodeTag.Invalid

    public validateSubmission(shouldShortCircuit: boolean): boolean {
        return false
    }

    public accept(visitor: TemplateNodeVisitor) {
        this.formNode.accept(visitor)

        if (this.toolboxContainer !== undefined) {
            this.toolboxContainer.accept(visitor);
        }
    }

    public getChildren(): DynamoNode[] {
        return [this.formNode, ...(this.toolboxContainer !== undefined ? [this.toolboxContainer] : [])]
    }

    public tryAddChild(child: DynamoNode, index?: number | undefined): boolean {
        return false
    }

    public tryRemoveChild(child: DynamoNode): boolean {
        const tryRemoveToolItem = () => {
            if (this.toolboxContainer === undefined) {
                return false
            }

            return this.toolboxContainer.tryRemoveChild(child);
        }

        return tryRemoveToolItem() || this.formNode.tryRemoveChild(child)
    }

    @observable formNode: FormNode

    @observable toolboxContainer?: ToolboxContainerNode;
}